import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  userDropdownContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },

  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '20px',
    color: '#fff',
  },

  roleText: {
    color: '#888',
  },

  dropdownContent: {
    position: 'absolute',
    top: '100%',
    fontSize: 15,
    fontStyle: 'bold',
    right: 20,
    backgroundColor: '#ffffff',
    borderRadius: '6px',
    border: '2px solid #8b7765',
    boxShadow: '0 0 8px #8b7765',
    zIndex: 1,
    minWidth: '100px',
    minHeight: '70px',
  },

  logoutLink: {
    marginTop: '0.5em',
    textAlign: 'center',
    display: 'block',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: '#4a1d76',
  },

  userManualLink: {
    marginTop: '0.5em',
    textAlign: 'center',
    display: 'block',
  },
});

export default useStyles;
